import { ETypeOfNotification, InputTextCustom, ResponseDTO, setNotification } from 'medere-ui-framework'
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl';
import { Bank, initialStateBank } from '../../interface/interface';
import { useLocation } from 'react-router';
import { Button } from 'primereact/button';
import { useDispatch } from 'react-redux';
import { useBankService } from '../../servicesHooks/Bank/useBankService';

type FormErrors = {
  companyname:boolean
}

export default function BankCRUDView({ closeModal, refreshTable, selectedBank }:any) {
    const intl = useIntl();
    const { createBank, getBankFull, updateBank } = useBankService();
    const [bank, setBank] = useState<Bank>(initialStateBank);
    const location = useLocation();
    const dispatch = useDispatch();
    const [formErrors, setFormErrors] = useState<FormErrors>({
      companyname: false
    });
  
    useEffect(() => {
      if (selectedBank) 
        setBank(selectedBank);
      else
        location.state && getBankFull(location.state.bankId).then((bank: Bank) => {
          setBank(bank);
        });
    }, []);
  
    const evaluateAndSetErrors = (): FormErrors => {
      const updatedErrors: FormErrors = { ...formErrors };
      if (!bank.companyname.trim()) {
        updatedErrors.companyname = true;
      }
      return updatedErrors;
    };
  
    function handleSave() {
      // Validar campos obligatorios (razón social, nombre comercial, estado, condición frente a IVA)
      let errors: FormErrors = evaluateAndSetErrors();
      const hasAnyError = Object.values(errors).some(Boolean);
      if (hasAnyError) {
        dispatch(setNotification({ title: intl.formatMessage({ id: "ThereAreMissingRequiredFields" }), typeOfNotification: ETypeOfNotification.WARNING }));
        setFormErrors(errors);
        return;
      }
  
      if (bank.bank == null || bank.bank < 1) {
        createBank(bank).then((id) => {
          if (id != null) {
            dispatch(setNotification({ title: intl.formatMessage({ id: 'ChangesSaved' }), icon: "pi-check-circle", typeOfNotification: ETypeOfNotification.INFO }));
            setBank({ ...bank, bank: id });
            refreshTable();
            closeModal();
          } else {
            dispatch(setNotification({ title: intl.formatMessage({ id: "ChangesCouldNotBeSaved" }), desc: '', icon: 'pi-times', typeOfNotification: ETypeOfNotification.WARNING }));
          }
        });
      } else {
        updateBank(bank).then((data: ResponseDTO) => {
          if (data.success != null) {
            dispatch(setNotification({ title: intl.formatMessage({ id: 'ChangesSaved' }), icon: "pi-check-circle", typeOfNotification: ETypeOfNotification.INFO }));
            refreshTable();
            closeModal();
          } else {
            dispatch(setNotification({ title: intl.formatMessage({ id: "ChangesCouldNotBeSaved" }), desc: '', icon: 'pi-times', typeOfNotification: ETypeOfNotification.WARNING }));
          }
        });
      }
    }
  
    return <React.Fragment>
      <div style={{marginLeft: '-10px', marginBottom:'-20px'}}>
        <Button className='btnCancel' label={'<<'+intl.formatMessage({ id: "Back" })} onClick={() => closeModal()} />
      </div>
      <div className='flex flex-column'>
        <InputTextCustom
          value={bank?.companyname ?? ""}
          onChange={(e) => {
            setBank({ ...bank, companyname: e.target.value });
            setFormErrors({ ...formErrors, companyname: false });
          }}
          floatLabel
          label={intl.formatMessage({ id: "firstname" })}
          error={formErrors.companyname}
        />
        <Button className='buttonMain align-self-end' label={intl.formatMessage({ id: "save" })} onClick={handleSave} />
      </div>
    </React.Fragment>;
  }
